import { useQuery } from "@tanstack/react-query";

import { OrdersTab } from "./OrdersTab";
import { ProductionTab } from "./ProductionTab";
import { SettingsTab } from "./SettingsTab";
import { StockTab } from "./StockTab";
import { UptimeTab } from "./UptimeTab";
import { getStockTab, STOCK_QUERY_KEY, type FreshnessMeta } from "./api";

/** The head query: sources the freshness line and warms the Stock tab's cache (one request). */
export function useOpsMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({ queryKey: STOCK_QUERY_KEY, queryFn: getStockTab, enabled });
  return enabled ? head.data?.meta : undefined;
}

/**
 * Tab content only. ShellPage wraps this in the shell-owned ModuleViewport and
 * PermissionGate; the permission prop and `ownerName` are accepted and not read (I-7).
 */
export function OpsModule({
  activeTabKey,
  areaName,
}: {
  decision: "edit" | "view" | "none";
  activeTabKey: string | null;
  areaName: string;
  ownerName?: string | null;
}) {
  if (activeTabKey === "settings") return <SettingsTab areaName={areaName} />;
  if (activeTabKey === "uptime") return <UptimeTab areaName={areaName} />;
  if (activeTabKey === "orders") return <OrdersTab areaName={areaName} />;
  if (activeTabKey === "production") return <ProductionTab areaName={areaName} />;
  return <StockTab areaName={areaName} />;
}
